module.exports = __webpack_public_path__ + "img/logo2.c95bcd9f.png";